import { Controller } from 'stimulus';

class FileInputController extends Controller {
  onInputChange() {
    let fileName = '';

    if (this.inputTarget.files && this.inputTarget.files.length > 1) {
      fileName = (this.inputTarget.dataset.multipleText || '').replace('{count}', this.inputTarget.files.length);
    } else {
      fileName = this.inputTarget.value.split('\\').pop();
    }

    this.labelTarget.innerText = fileName;
  }
}

FileInputController.targets = [
  'input',
  'label',
];

export default FileInputController;
